import React, { useState } from 'react';

const Header: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        setIsMenuOpen(false); // Close mobile menu
    };

    return (
        <header className="bg-white dark:bg-gray-900 shadow-lg fixed w-full top-0 z-50">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center py-4">

                    {/* Logo/Name */}
                    <div className="flex-shrink-0">
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                            Christer Bengtsson
                        </h1>
                        <p className="text-sm text-gray-600 dark:text-gray-300">
                            Fullstack Developer
                        </p>
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex space-x-8">
                        <button
                            onClick={() => scrollToSection('hero')}
                            className="text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary transition-colors duration-200"
                        >
                            Home
                        </button>
                        <button
                            onClick={() => scrollToSection('about')}
                            className="text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary transition-colors duration-200"
                        >
                            About
                        </button>
                        <button
                            onClick={() => scrollToSection('projects')}
                            className="text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary transition-colors duration-200"
                        >
                            Projects
                        </button>
                        <button
                            onClick={() => scrollToSection('contact')}
                            className="text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary transition-colors duration-200"
                        >
                            Contact
                        </button>
                    </nav>

                    {/* Mobile menu button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="text-gray-700 dark:text-gray-300 hover:text-primary focus:outline-none focus:text-primary"
                        >
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                {isMenuOpen ? (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                ) : (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                )}
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Mobile Navigation */}
                {isMenuOpen && (
                    <div className="md:hidden">
                        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white dark:bg-gray-900 border-t dark:border-gray-700">
                            <button
                                onClick={() => scrollToSection('hero')}
                                className="block px-3 py-2 text-gray-700 dark:text-gray-300 hover:text-primary w-full text-left"
                            >
                                Home
                            </button>
                            <button
                                onClick={() => scrollToSection('about')}
                                className="block px-3 py-2 text-gray-700 dark:text-gray-300 hover:text-primary w-full text-left"
                            >
                                About
                            </button>
                            <button
                                onClick={() => scrollToSection('projects')}
                                className="block px-3 py-2 text-gray-700 dark:text-gray-300 hover:text-primary w-full text-left"
                            >
                                Projects
                            </button>
                            <button
                                onClick={() => scrollToSection('contact')}
                                className="block px-3 py-2 text-gray-700 dark:text-gray-300 hover:text-primary w-full text-left"
                            >
                                Contact
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;